module.exports = __webpack_public_path__ + "img/logo.ac5c68a0.png";